import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class CentroCustoService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.url = SCAMP_API.accountApiV1;
    }
    getCentrosCustos() {
        return this.http.get(`${SCAMP_API.accountApiV1}/centroscustos`, { headers: this.account.composeHeaders() });
    }
    getCentrosCustosx() {
        return fetch(`${this.url}/centroscustos`, {
            headers: {
                "Authorization": this.account.composeHeaders().keys["Authorization"]
            }
        })
            .then(res => res.json());
        //return this.http.get<CentroCusto[]>(`${SCAMP_API.accountApiV1}/centroscustos`, { headers: this.account.composeHeaders() });
    }
    getCentroCustoDetalhes(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/centrocustodetalhes/${id}`, { headers: this.account.composeHeaders() });
    }
    get(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/centrocustos/${id}`, { headers: this.account.composeHeaders() });
    }
    isUniqueCentroCusto(nome) {
        return this.http.post(`${SCAMP_API.accountApiV1}/centrocustos/is-unique`, { nome }, { headers: this.account.composeHeaders() });
    }
    post(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/centrocustos`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/centrocustos/${id}`, { headers: this.account.composeHeaders() });
    }
    list() {
        return this.http.get(`${SCAMP_API.accountApiV1}/centroscustos`, { headers: this.account.composeHeaders() });
    }
}
CentroCustoService.ngInjectableDef = i0.defineInjectable({ factory: function CentroCustoService_Factory() { return new CentroCustoService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: CentroCustoService, providedIn: "root" });
